import 'fslightbox'

window.addEventListener('bw-refresh-lightbox', () => {
  // @ts-expect-error: CDN
  refreshFsLightbox()
})
